export default __webpack_public_path__ + "static/media/Leaders_IMG-01.18dd87bf.png";